import { Box } from '@mui/material';
import { FunctionComponent } from 'react';

interface Props {
  title: string;
}

export const TopologyFiltersSectionHeader: FunctionComponent<Props> = ({ title }) => {
  return <Box sx={{ fontWeight: 'bold', my: 2 }}>{title}</Box>
}
